import * as React from "react";
import { MeasuredComponentProps, withContentRect } from "react-measure";
import { Deployment } from "../domain/deployment";
import * as Dims from "../domain/dimension";
import { Dimensions, summaryKey } from "../domain/dimension";
import { medianAverageForOrgs, Organization, Year } from "../domain/organization";
import LineRule from "./LineRule";
import { ViolinDatum, ViolinMargin } from "./Violin";
import ViolinGrid, { ViolinGridMode } from "./ViolinGrid";
import * as ViolinGridConstants from "./ViolinGridConstants";

const ResizableViolinGrid = (props: ResizableViolinGridProps & { width: number; height: number }) => {
  const width = props.width;
  const violinMargin = (props.violinMarginForWidth && props.violinMarginForWidth(width)) || ({} as ViolinMargin);
  const violinWidth = Math.round(width) + (violinMargin.right || 0) + (violinMargin.left || 0);
  const violinHeight =
    Math.round(width / ViolinGridConstants.VIOLIN_ASPECT_RATIO_IN_LIST) +
    (violinMargin.top || 0) +
    (violinMargin.bottom || 0);

  const { lineRuleTitle, lineRuleAvg } = props;
  const avg =
    lineRuleAvg != null
      ? lineRuleAvg
      : medianAverageForOrgs(props.organizationsData, Dims.selected(props.dims) || summaryKey);

  return (
    <div>
      <ViolinGrid {...props} violinWidth={violinWidth} violinHeight={violinHeight} violinMargin={violinMargin} />

      {props.showLineRuleAvg && (
        <LineRule title={lineRuleTitle != null ? lineRuleTitle : ""} width={violinWidth} value={avg} domain={[0, 7]} />
      )}
    </div>
  );
};

export interface ResizableViolinGridProps {
  deployment: Deployment;
  mode: ViolinGridMode;
  organizationsData: Organization[];
  dims: Dimensions | any;

  offsetY?: number;
  selectedViolinId?: string;
  highlightedViolinId?: string;

  className?: string;
  violinClassName?: any;
  violinMargin?: ViolinMargin;

  valueFormat(n: number): string;
  showSummaryDimAsOutline?: boolean;
  showRanks?: boolean;
  showRatings?: boolean;
  showDelta?: boolean;
  showLinksToDetailPage?: boolean;
  showAvgValueText?: boolean;
  showAxisTicks?: boolean;
  enableTooltip?: boolean;
  violinMarginForWidth?: (n: number) => ViolinMargin;

  onMouseEnter?: (d: ViolinDatum) => void;
  onMouseLeave?: (d: ViolinDatum) => void;

  suppressTransitions?: any;

  showLineRuleAvg: boolean;
  selectedYear: Year;
  lineRuleAvg?: any;
  lineRuleTitle?: any;
}

const _ResizableViolinGrid = (props: ResizableViolinGridProps & MeasuredComponentProps) => (
  <div style={{ position: "relative" }} ref={props.measureRef}>
    {props.contentRect.bounds &&
      props.contentRect.bounds.width !== undefined &&
      props.contentRect.bounds.height !== undefined && (
        <ResizableViolinGrid
          {...props}
          width={props.contentRect.bounds.width}
          height={props.contentRect.bounds.height}
        />
      )}
  </div>
);

export default withContentRect("bounds")(_ResizableViolinGrid);
